import React from "react";
import "./ExamEndScreen.css";

const ExamEndScreen = ({ reason }) => {
  return (
    <div className="exam-end-screen">
      <div className="end-screen-content">
        <div className="end-screen-logo">
          {/* Add your logo here */}
          <span>ElCarreira®</span>
        </div>

        <div className="end-screen-message">
          <h1>Exam Complete</h1>

          <div className="completion-status">
            {reason === "TIMEOUT" ? (
              <>
                <p>Your exam session has ended as the time has expired.</p>
                <p>Your answers have been automatically submitted.</p>
              </>
            ) : reason === "UPLOADED" ? (
              <>
                <p>Your answers have been successfully uploaded.</p>
                <p>They will be reviewed by your examiner.</p>
              </>
            ) : reason === "SUBMITTED" ? (
              <>
                <p>Your answers have been successfully submitted.</p>
                <p>Thank you for completing your examination.</p>
              </>
            ) : (
              <p>Your exam session has ended.</p>
            )}
          </div>

          <div className="thank-you-message">
            <h2>Thank You</h2>
            <p>for completing your examination</p>
          </div>

          <div className="exit-message">You may now close this window</div>
        </div>
      </div>
    </div>
  );
};

export default ExamEndScreen;
